import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

type TabItemPrpos = {
  active?: boolean;
};

export const TabItem = styled.div<TabItemPrpos>`
  cursor: pointer;
  padding: 12px 8px;
  flex: 1;
  display: flex;
  align-items: center;
  border: 1px solid #cbcbcb;
  -webkit-transition: border 0.3s;
  transition: border 0.3s;
  justify-content: center;
  display: flex;
  align-items: center;
  gap: 8px;

  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  ${({ active }) =>
    active &&
    css`
      border: 1px solid #0b29fb;
    `}
`;

export const TabText = styled.span<TabItemPrpos>`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;
  transition: color 0.3s;

  ${({ active }) =>
    active &&
    css`
      color: #0b29fb;
    `}
`;

export const Count = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;
  padding: 3px 10px;
  border-radius: 16px;
  background: #d9d9d9;
`;
